var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPointerDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m3.764 10.933 6.632 6.633.854.854V2.5h1.5v15.918l.853-.852 6.634-6.622L21.293 12 12 21.293l-9.294-9.294z"
})));
export { SvgPointerDown as ReactComponent };
export default __webpack_public_path__ + "5f8a509660542dcb9744d6bd69f219ff.svg";